import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import './Skeleton.scss';
import MediaContainer from '../mediaSection/MediaContainer';
import FooterContainer from '../footerSection/FooterContainer';
import DetailsContainer from '../detailsSection/DetailsContainer';

const VehicleCardSkeleton = ({
	index,
	isGridLayout,
	isTabbedLayout,
	uuid,
	forwardedRef,
	enableFirstSkeletonImg,
	ssrPlaceholderImage
}) => {
	return (
		<li
			className={setClassNames([
				'box',
				'box-border',
				'vehicle-card',
				'vehicle-card-detailed',
				isGridLayout ? null : 'vehicle-card-horizontal horizontal'
			])}
			data-uuid={uuid}
			data-index={index}
			ref={forwardedRef}
		>
			<div
				className={setClassNames([
					'vehicle-card-body',
					'ddc-font-size-small',
					isGridLayout ? null : 'd-sm-flex flex-sm-row' // TODO: deprecate
				])}
			>
				<MediaContainer
					shouldFullyRenderCard={false}
					enableFirstSkeletonImg={enableFirstSkeletonImg}
					ssrPlaceholderImage={ssrPlaceholderImage}
				/>
				<DetailsContainer
					isTabbedLayout={isTabbedLayout}
					shouldFullyRenderCard={false}
				/>
			</div>
			<FooterContainer shouldFullyRenderCard={false} />
		</li>
	);
};

const WrappedVehicleCardSkeleton = React.forwardRef((props, ref) => {
	return <VehicleCardSkeleton {...props} forwardedRef={ref} />;
});

VehicleCardSkeleton.propTypes = {
	index: PropTypes.number,
	isGridLayout: PropTypes.bool.isRequired,
	isTabbedLayout: PropTypes.bool.isRequired,
	// only needed for substitution, not needed during initial load
	forwardedRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	uuid: PropTypes.string,
	enableFirstSkeletonImg: PropTypes.bool,
	ssrPlaceholderImage: PropTypes.string
};

VehicleCardSkeleton.defaultProps = {
	forwardedRef: null,
	uuid: undefined,
	index: undefined,
	enableFirstSkeletonImg: undefined,
	ssrPlaceholderImage: null
};

export default WrappedVehicleCardSkeleton;
